import angular from 'angular';
import tooltipMobileComponent from './tooltipMobile.component';

let tooltipMobileModule = angular.module('tooltipMobile', [
])

.component('tooltipMobile', tooltipMobileComponent)

.name;

export default tooltipMobileModule;



// WEBPACK FOOTER //
// ./client/app/components/tooltipMobile/tooltipMobile.js